import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import { Text } from 'shared/components';
import useStyles from './styles';
import Icon from '@mui/material/Icon';

const IntroItem = ({ title, description, icon, onClick }) => {
  const classes = useStyles();
  const [isHover, setIsHover] = useState(false);

  const onMouseEnterHandler = () => {
    setIsHover(true);
  };

  const onMouseLeaveHandler = () => {
    setIsHover(false);
  };

  const animation = isHover ? { transform: 'translateY(0)' } : {};

  return (
    <Card
      className={classes.card}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
      onClick={onClick && onClick}
    >
      <Icon color="primary" className={classes.icon}>{icon}</Icon>
      <div className={classes.descriptionBox} style={animation}>
        <Text className={classes.title}>{title}</Text>
        {description}
      </div>
    </Card>
  );
};

IntroItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func
};

export default IntroItem;
